import api from './api';
import { AuthResponse, User } from '../types';

export const authService = {
  async login(username: string, password: string): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/login', {
      username,
      password,
    });
    
    // Store token
    localStorage.setItem('auth-token', response.data.token);
    
    return response.data;
  },

  async logout(): Promise<void> {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      // Ignore errors on logout
    } finally {
      localStorage.removeItem('auth-token');
    }
  },

  async verifyToken(): Promise<{ valid: boolean; user: User }> {
    const response = await api.get('/auth/verify');
    return response.data;
  },

  getToken(): string | null {
    return localStorage.getItem('auth-token');
  },

  isAuthenticated(): boolean {
    return !!this.getToken();
  },
};